(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('environment', {
            parent: 'entity',
            url: '/environment?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'uniromaLandingApp.environment.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/environment/environments.html',
                    controller: 'EnvironmentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('environment');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('environment-detail', {
            parent: 'environment',
            url: '/environment/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'uniromaLandingApp.environment.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/environment/environment-detail.html',
                    controller: 'EnvironmentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('environment');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Environment', function($stateParams, Environment) {
                    return Environment.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'environment',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('environment-detail.edit', {
            parent: 'environment-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/environment/environment-dialog.html',
                    controller: 'EnvironmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Environment', function(Environment) {
                            return Environment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('environment.new', {
            parent: 'environment',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/environment/environment-dialog.html',
                    controller: 'EnvironmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                type: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('environment', null, { reload: 'environment' });
                }, function() {
                    $state.go('environment');
                });
            }]
        })
        .state('environment.edit', {
            parent: 'environment',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/environment/environment-dialog.html',
                    controller: 'EnvironmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Environment', function(Environment) {
                            return Environment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('environment', null, { reload: 'environment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('environment.delete', {
            parent: 'environment',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/environment/environment-delete-dialog.html',
                    controller: 'EnvironmentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Environment', function(Environment) {
                            return Environment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('environment', null, { reload: 'environment' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
